import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';
import {
  CreateEstablishmentFromBulkParams,
  CreateEstablishmentParams,
  Establishment,
  ListEstablishmentRequestParams,
  UpdateEstablishmentParams
} from '~core/models/establishment.model';
import { OrganizationHeadquartersCreationParams } from '~core/models/organization.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class EstablishmentService {
  private _apiConstantsService = inject(ApiConstantsService);
  readonly apiUrl = this._apiConstantsService.establishmentsUrl;
  private _httpClient = inject(HttpClient);

  createFromBulk(params: CreateEstablishmentFromBulkParams): Observable<void> {
    const formData = new FormData();
    formData.append('organizationId', params.organizationId);
    formData.append('file', params.file);

    return this._httpClient.post<void>(
      `${this.apiUrl}/create-from-bulk`,
      formData
    );
  }

  read(establishmentId: string): Observable<Establishment> {
    return this._httpClient.get<Establishment>(
      `${this.apiUrl}/${establishmentId}`
    );
  }

  list(
    params?: ListEstablishmentRequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<Establishment>> {
    return this._httpClient.get<Pagination<Establishment>>(this.apiUrl, {
      params: {
        ...params,
        sort: params?.sort || 'createdAt',
        desc: params?.desc || 'createdAt'
      } as Record<string, any>
    });
  }

  create(data: CreateEstablishmentParams): Observable<Establishment> {
    return this._httpClient.post<Establishment>(this.apiUrl, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  createDefault(
    organizationId: string,
    payload: OrganizationHeadquartersCreationParams
  ): Observable<Establishment> {
    return this._httpClient.post<Establishment>(
      `${this._apiConstantsService.organizationUrl}/${organizationId}/establishments/default`,
      payload
    );
  }

  update(
    id: string,
    data: Partial<UpdateEstablishmentParams>
  ): Observable<Establishment> {
    return this._httpClient.patch<Establishment>(`${this.apiUrl}/${id}`, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  delete(establishmentId: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(
      `${this.apiUrl}/${establishmentId}`
    );
  }
}
